import React from "react";
import TrueIcon from "../components/Icons/True";
import FalseIcon from "../components/Icons/False";
import { StyledPricing } from "../components/Styles";
import Consultation from "../components/Consultation";
import { useTranslation } from "react-i18next";

const WepAppPricing = () => {
  const { t, i18n } = useTranslation();

  return (
    <StyledPricing.Container>
      <StyledPricing.Description>
        <p>
          <StyledPricing.Title lang={i18n.language}>
            {t("webAppPricing.title")}
          </StyledPricing.Title>

          {t("webAppPricing.intro")}
          <br />
          {t("webAppPricing.stepsTitle")}

          <ul>
            {["step1", "step2", "step3", "step4"].map((step) => (
              <li key={step}>
                <TrueIcon color={"#caa037"} width={14} height={14} />
                <span>{t(`webAppPricing.steps.${step}`)}</span>
              </li>
            ))}
          </ul>

          {t("webAppPricing.conclusion")}
        </p>
      </StyledPricing.Description>

      <StyledPricing.PricingTable>
        <StyledPricing.Table>
          <thead>
            <StyledPricing.HeaderRow>
              <StyledPricing.HeaderCell></StyledPricing.HeaderCell>
              <StyledPricing.HeaderCell>
                {t("webAppPricing.table.basic")}
              </StyledPricing.HeaderCell>
              <StyledPricing.HeaderCell>
                {t("webAppPricing.table.standard")}
              </StyledPricing.HeaderCell>
            </StyledPricing.HeaderRow>
          </thead>

          <tbody>
            {/* Text Rows */}
            {[
              ["design", "fivePages", "tenPages"],
              ["hosting", "hostingBasic", "hostingStandard"],
              ["support", "sixMonths", "twelveMonths"],
              ["traffic", "quarterly", "monthly"],
              ["contentUpdates", "biMonthly", "monthly"],
            ].map(([label, basic, standard]) => (
              <StyledPricing.Row key={label}>
                <StyledPricing.Cell lang={i18n.language}>
                  {t(`webAppPricing.table.${label}`)}
                  <span></span>
                </StyledPricing.Cell>
                <StyledPricing.Cell>
                  {t(`webAppPricing.table.${basic}`)}
                </StyledPricing.Cell>
                <StyledPricing.Cell>
                  {t(`webAppPricing.table.${standard}`)}
                </StyledPricing.Cell>
              </StyledPricing.Row>
            ))}

            {/* Included in Both */}
            {[
              "responsive",
              "consultationForm",
              "comments",
              "security",
              "training",
              "admin",
              "social",
            ].map((label) => (
              <StyledPricing.Row key={label}>
                <StyledPricing.Cell lang={i18n.language}>
                  {t(`webAppPricing.table.${label}`)}
                  <span></span>
                </StyledPricing.Cell>
                <StyledPricing.Cell><TrueIcon /></StyledPricing.Cell>
                <StyledPricing.Cell><TrueIcon /></StyledPricing.Cell>
              </StyledPricing.Row>
            ))}

            {/* Standard Only */}
            {[
              "domain",
              "authentication",
              "seo",
            ].map((label) => (
              <StyledPricing.Row key={label}>
                <StyledPricing.Cell lang={i18n.language}>
                  {t(`webAppPricing.table.${label}`)}
                  <span></span>
                </StyledPricing.Cell>
                <StyledPricing.Cell><FalseIcon /></StyledPricing.Cell>
                <StyledPricing.Cell><TrueIcon /></StyledPricing.Cell>
              </StyledPricing.Row>
            ))}

            <StyledPricing.Row>
              <StyledPricing.Cell></StyledPricing.Cell>
              <StyledPricing.Cell>{t("webAppPricing.table.price-basic")}</StyledPricing.Cell>
              <StyledPricing.Cell>{t("webAppPricing.table.price-standard")}</StyledPricing.Cell>
            </StyledPricing.Row>
          </tbody>
        </StyledPricing.Table>
      </StyledPricing.PricingTable>

      <div>
        <Consultation text={
          <>
            {t("customPackage")}
            <br />
            {t("contactus")}
          </>
        } />
      </div>
    </StyledPricing.Container>
  );
};

export default WepAppPricing;